import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, TextField, MenuItem, CircularProgress } from "@mui/material";
import MDButton from "components/MDButton";
import { useAlerta } from "utils/alertas";

export default function AgregarGrupoModal({ open, onClose, onGrupoAgregado,moduloId,gestionId }) {
  const [nombre, setNombre] = useState("");
  const [turno, setTurno] = useState("");
  const [modalidad, setModalidad] = useState("");
  const [dias , setDias]= useState("");
  const [capacidad, setCapacidad] = useState(""); 
  const [estado, setEstado] = useState(1); // activo por defecto
  const [loading, setLoading] = useState(false);
  const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");

  const handleSemestreChange = (event) => {
      setSemestre(event.target.value);
    } 

  const handleSubmit = () => {
    

    setLoading(true);

    fetch(`${process.env.REACT_APP_API_URL}/grupos/capacitacion`, { 
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        nombre,
        turno,
        modalidad,
        cupo_maximo: capacidad ? parseInt(capacidad) : null,
        dias,
        estado,
        gestion_id: gestionId,
        capacitacion_id: moduloId,
      }),
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.message || "Error al agregar grupo");
        }
        return data;
      })
      .then((data) => {
        mostrarAlerta("Grupo creado correctamente", "success");
        setLoading(false);

        if (onGrupoAgregado) onGrupoAgregado(); 

        onClose();
        setNombre("");
        setTurno("");
        setModalidad("");
        setDias("");
        setCapacidad("");
        setEstado(1);
      })
      .catch((err) => {
        console.error("Error al agregar grupo:", err);
        mostrarAlerta(err.message || "Error al agregar grupo", "error");
        setLoading(false);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Agregar Grupo
        </Typography>

        <TextField
          fullWidth
          label="Nombre del Grupo"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          select
          fullWidth
          label="Turno"
          value={turno}
          onChange={(e) => setTurno(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""></option>
          <option value="mañana">Mañana</option>
          <option value="tarde">Tarde</option>
          <option value="noche">Noche</option>
        </TextField>
        <TextField
          select
          fullWidth
          label="Modalidad"
          value={modalidad}
          onChange={(e) => setModalidad(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""> </option>
          <option value="presencial">Presencial</option>
          <option value="semipresencial">Semi presencial</option>
          <option value="virtual">Virtual</option>
        </TextField>
        <TextField
          select
          fullWidth
          label="Dias"
          value={dias}
          onChange={(e) => setDias(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}        
        >
          <option value=""></option>
          <option value="lunes_a_viernes">Lunes a Viernes</option>
          <option value="lunes_miercoles_viernes">Lunes, miercoles, viernes</option>
          <option value="martes_jueves"> Martes, jueves</option>
          <option value="sabados">sabado</option>
        </TextField>
        <TextField
          fullWidth
          label="Capacidad"
          type="number"
          value={capacidad}
          onChange={(e) => setCapacidad(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          select
          fullWidth
          label="Estado"
          value={estado}
          onChange={(e) => setEstado(parseInt(e.target.value))}
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        >
          <MenuItem value={1}>Activo</MenuItem>
          <MenuItem value={0}>Inactivo</MenuItem>
        </TextField>

        <MDButton
          variant="contained"
          color="info"
          fullWidth
          onClick={handleSubmit}
          disabled={loading}
          sx={{ color: "#fff" }}
        >
          {loading ? <CircularProgress size={24} /> : "Agregar Grupo"}
        </MDButton>
      </Box>
    </Modal>
  );
}
